export const DAY_DATE_FORMAT = "YYYY-MM-DD";

// we do not deal with seconds
export const DAY_DATETIME_FORMAT = "YYYY-MM-DD[T]HH:mm";

// we do not deal with seconds
export const DAY_TIME_FORMAT = "HH:mm";

// Zero-padded localized date per cvp-design.md ("01.04.2026, not 1.4.2026").
// `L` (uppercase) gives the padded version — `l` (lowercase) gave `1.4.2026`
// which violated the design rule.
export const VISUAL_DATE_FORMAT = "L"; // M/D/YYYY for EN, DD.MM.YYYY for NB etc
export const VISUAL_DATETIME_FORMAT = "L LT";
export const VISUAL_TIME_FORMAT = "LT"; // becomes h:mm A for EN, HH:mm for NB etc
export const VISUAL_TIME_FORMAT_DAY = "ddd";
export const VISUAL_TIME_FORMAT_DAY_LONG = "dddd";

export const CLEAN_VISUAL_DATE_FORMAT = "DDMMYYYY";

/** Reserved vertical space for fixed TopBar. Keep in sync with TopBar `height`. */
export const CVP_TOP_BAR_RESERVED_HEIGHT = "3rem";
